var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.$store.state.user)?_c('div',[_c('NavBar'),_c('router-view',{staticClass:"ml-14 mt-16",on:{"update_nav":function($event){return _vm.update_nav($event)}}})],1):_c('div',[_c('Config')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }